<template>
	<div>
		<div id="sidebar" class="app-sidebar">
			<vue-custom-scrollbar class="app-sidebar-content">
				<div class="menu">
					<template v-for="(menu, index) in appSidebarMenu">
						<div class="menu-header" v-if="menu.is_header" v-bind:key="index">{{ menu.text }}</div>
						<div class="menu-divider" v-else-if="menu.is_divider" v-bind:key="index"></div>
						<sidebar-nav v-else ref="sidebarNav"
							v-bind:key="index"
							v-bind:menu="menu"
							v-on:collapse-other="handleCollapseOther(menu)"
							v-on:showFloatSubmenu="handleShowFloatSubmenu"
							v-on:hideFloatSubmenu="handleHideFloatSubmenu"></sidebar-nav>
					</template>
                    <template>
                        <div ref="myHeader" class="use-header">Useful Link:</div>
                        <a ref="myElement" class="use-item" v-for="(link,i) in userfulLink" :key="i+2" @click="getLink(link)">{{link.name}}</a>
                    </template>
				</div>
			</vue-custom-scrollbar>

			<button class="app-sidebar-mobile-backdrop" v-on:click="dismissAppSidebarMobile"></button>
		</div>

		<div class="app-float-submenu" @mouseover="clearHideFloatSubmenu" @mouseleave="handleHideFloatSubmenu"
			v-if="this.appOptions.appSidebarMinified && !this.refreshSubmenu"
			v-bind:class="{ 'd-none': !this.floatSubmenu }"
			v-bind:style="{
				top: this.floatSubmenuTop,
				left: this.floatSubmenuLeft,
				bottom: this.floatSubmenuBottom,
				right: this.floatSubmenuRight
			}">
			<sidebar-nav v-for="(submenu, index) in this.floatSubmenuMenu"
				ref="sidebarFloatNav"
				v-bind:menu="submenu"
				v-bind:key="index"
				v-on:calcFloatSubmenu="handleCalcFloatSubmenu"></sidebar-nav>
		</div>
	</div>
</template>

<script>
import AppSidebarMenu from '../config/AppSidebarMenu.vue'
import AppOptions from '../config/AppOptions.vue'
import SidebarNav from './SidebarNav.vue'

export default {
	name: 'Sidebar',
  data() {
		return {
			appOptions: AppOptions,
			appSidebarMenu: AppSidebarMenu,
			floatSubmenu: false,
			floatSubmenuMenu: '',
			floatSubmenuTop: '',
			floatSubmenuBottom: '',
			floatSubmenuLeft: '',
			floatSubmenuRight: '',
			clearSubmenu: '',
			subMenuOffset: '',
			refreshSubmenu: false,
            userfulLink: [
                {
                    name:"NAS",
                    url:"http://file.monkeytree.com.hk:9080/cgi-bin/"
                },
                {
                    name:"Schoolnet",
                    url:" https://schoolnet.monkeytree.com.hk/monkeyTree/main.jsp"
                },
                {
                    name:"Mailbox",
                    url:" https://mailbox.monkeytree.com.hk/"
                },
                {
                    name:"ERP",
                    url:"https://erp.monkeytree.com.hk/auth/login"
                },
                {
                    name:"Monkey Town",
                    url:"http://monkeytown.monkeytree.com.hk/#/"
                },
                // {
                //     name:"Trello",
                //     url:"https://trello.com/"
                // },
            ]
		}
  },
	components: {
		SidebarNav
	},
    mounted() {
        const myDiv = document.querySelector('.app-sidebar');
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const newWidth = entry.contentRect.width;
                const myElement = this.$refs.myElement;
                const myHeader = this.$refs.myHeader;

                if(newWidth === 64){
                    myHeader.style.width = "55px"
                    myHeader.style.margin = "3px 4px"
                    myHeader.style.whiteSpace = "nowrap"
                    myHeader.style.overflow = "hidden"
                    myHeader.style.textOverflow = "ellipsis"
                    myElement.forEach((item)=>{
                        item.style.width = "55px"
                        item.style.margin = "3px 4px"
                        item.style.fontSize = "12px"
                        item.style.whiteSpace = "nowrap"
                        item.style.overflow = "hidden"
                        item.style.textOverflow = "ellipsis"
                    })
                }
                if(newWidth === 239){
                    myElement.forEach((item)=>{
                        item.style.width = "100px"
                        item.style.margin = "3px 20px"
                        item.style.fontSize = "14px"
                    })
                    myHeader.style.width = "100px"
                    myHeader.style.margin = "3px 20px"
                }
                // 处理宽度变化的逻辑
                // console.log("图表展示尺寸==>",newWidth);
            }
        });
        resizeObserver.observe(myDiv);
    },
	methods: {
		dismissAppSidebarMobile() {
			this.appOptions.appSidebarMobileClosed = true;

			setTimeout(() => {
				this.appOptions.appSidebarMobileClosed = false;
				this.appOptions.appSidebarMobileToggled = false;
			}, 250);
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.appSidebarMenu.length; i++) {
				if(this.$refs.sidebarNav[i]) {
					this.$refs.sidebarNav[i].collapse(menu);
				}
			}
		},
		handleCalcFloatSubmenu: function() {
			setTimeout(() => {
				var targetTop = this.subMenuOffset.top;
				var windowHeight = window.innerHeight;
				var targetHeight = document.querySelector('.app-float-submenu').offsetHeight;

				if ((windowHeight - targetTop) > targetHeight) {
					this.floatSubmenuTop = this.subMenuOffset.top + 'px';
					this.floatSubmenuBottom = 'auto';
				} else {
					this.floatSubmenuTop = 'auto';
					this.floatSubmenuBottom = '0';
				}
			}, 0);
		},
		handleShowFloatSubmenu: function(data, offset) {
			if (data != this.floatSubmenuMenu) {
				this.refreshSubmenu = true;
			}

			if (this.refreshSubmenu != true) {
				this.floatSubmenuMenu = data;
				this.floatSubmenu = true;
				this.subMenuOffset = offset;
				this.refreshSubmenu = false;
			}

			var targetTop = offset.top;
			var windowHeight = window.innerHeight;
			var targetHeight = document.querySelector('.app-float-submenu').offsetHeight;

			setTimeout(() => {
				if (this.refreshSubmenu == true) {
					this.refreshSubmenu = false;
					this.floatSubmenuMenu = data;
					this.floatSubmenu = true;
					this.subMenuOffset = offset;
					this.refreshSubmenu = false;
				}


				if ((windowHeight - targetTop) > targetHeight) {
					this.floatSubmenuTop = offset.top + 'px';
					this.floatSubmenuBottom = 'auto';
				} else {
					this.floatSubmenuTop = 'auto';
					this.floatSubmenuBottom = '0';
				}
			}, 0);

			this.floatSubmenuRight = 'auto';
			this.floatSubmenuLeft = (document.getElementById('sidebar').offsetLeft + offset.width) + 'px';

			clearTimeout(this.clearSubmenu);
		},
		handleHideFloatSubmenu: function() {
			this.clearSubmenu = setTimeout(() => {
				this.floatSubmenu = false;
			}, 250);
		},
		clearHideFloatSubmenu: function() {
			clearTimeout(this.clearSubmenu);
		},
        getLink(item){
            // console.log(item)
            window.open(item.url)
        },
	}
}
</script>

<style>
   .app-sidebar .app-sidebar-content .use-header {
       margin: 8px 20px;
       font-size: 0.7875rem;
       font-weight: 600;
       color: #657eae;
   }
   .app-sidebar .app-sidebar-content .use-item {
       margin: 3px 20px;
       font-weight: bold;
       color: #3c4e71;
       cursor: pointer;
       width: 100px;
       //background: #1f6bff;
   }
   .app-sidebar .app-sidebar-content .use-item:hover {
       color: crimson;
   }
</style>
